import { mapActions } from "vuex";
import * as types from "@/store/types";
import { AuthService } from "@/services";
import LoginBanner from "@/components/Auth/Login/loginBanner.vue";
import initService from "@/services/modules/initService";
// import debounce from "lodash-es/debounce";
const Captcha = () =>
  import(/* webpackChunkName: "Captcha" */ "@/components/Captcha/index");
export default {
  name: "loginForm",
  components: { Captcha, LoginBanner },
  props: [],
  data() {
    return {
      loading: false,
      show1: false,
      emailOrMobile: "",
      password: "",
      passwordValidation: [
        () =>
          !!this.password ||
          this.$t("authPage.loginPage.password.validation.notEmpty"),
        v =>
          !/^[\u0600-\u06FF\uFB8A\u067E\u0686\u06AF]+$/.test(
            v.replace(/\s/g, "")
          ) || this.$t("authPage.loginPage.password.validation.notPersian")
      ],
      valid: false,
      captcha_token: null,
      captcha_value: null,
      captcha_hash: null,
      reloadCaptcha: false,
      cookieURL: process.env.VUE_APP_MAIN_BASE_URL,
      marketURL: process.env.VUE_APP_MARKET_BASE_URL,
      captchaStatus: false
    };
  },
  computed: {},
  mounted() {
    this.getCaptchaStatus();
  },
  methods: {
    ...mapActions({
      checkIsAuth: types.auth.actions.ACTION_CHECK_IS_AUTH
    }),
    getCaptchaStatus() {
      initService.initSecurity().then(res => {
        this.captchaStatus = res.data.data.captcha.users_sign_in;
      });
    },
    captchaChanged(captchaData) {
      this.captcha_token = captchaData.token;
      this.captcha_value = captchaData.value;
    },
    onSubmit() {
      if (!this.loading) {
        // this.$refs.form.validate();
        this.loading = true;
        // if (this.$refs.form.validate()) {
        //   this.verifyRegistration();
        // } else {
        //   this.loading = false;
        // }
        this.loginUser();
      }
    },
    loginUser() {
      AuthService.signIn(
        this.emailOrMobile,
        this.password,
        this.captcha_token,
        this.captcha_value
      )
        .then(response => {
          this.setToken(response.data.data);
        })
        .catch(error => {
          this.captcha_token = null;
          this.captcha_value = null;
          this.captcha_hash = error.data.captcha_hash;
        })
        .finally(() => {
          this.loading = false;
          this.reloadCaptcha = !this.reloadCaptcha;
        });
    },
    setToken(data) {
      let {
        default_2fa_method,
        google2fa_token,
        otp_token,
        email,
        token,
        refresh_token,
        ttl,
        mobile
      } = data;
      if (default_2fa_method === "google2fa") {
        localStorage.setItem("google2faToken", google2fa_token);
        localStorage.setItem("emailOrMobile", this.emailOrMobile);
        this.$router.push(`/auth/login/google-auth`);
      } else if (default_2fa_method === "otp") {
        localStorage.setItem("ttl", ttl);
        localStorage.setItem("otpToken", otp_token);
        localStorage.setItem("emailOrMobile", mobile);
        this.$router.push(`/auth/login/otp-auth`);
      } else if (default_2fa_method === "email") {
        localStorage.setItem("ttl", ttl);
        localStorage.setItem("emailOtpToken", otp_token);
        localStorage.setItem("emailOrMobile", email);
        this.$router.push(`/auth/login/email-auth`);
      } else if (token) {
        // localStorage.setItem("accessToken", token);
        localStorage.setItem("isAuth", "true");
        localStorage.setItem("accessToken", token);

        localStorage.setItem("refreshToken", refresh_token);
        this.$cookies.set("refreshToken", refresh_token);

        this.$cookies.set("accessToken", token);
        this.checkIsAuth();
        if (this.$route.query.marketRedirect) {
          window.location.replace(
            this.marketURL + this.$route.query.marketRedirect
          );
        } else {
          if (this.$route.query.redirectFrom) {
            this.$router.push(this.$route.query.redirectFrom);
          } else {
            this.$router.push(`/dashboard`);
          }
        }
      }
    }
    /*showNotification() {
      let option = {
        body: "this is body of notification",
        icon: "/img/icons/android-96x196.png"
      };
      new Notification("hi this is from chaintracker", option);
    }*/
  }
};
